import Footer from "../components/footer";
import Header from "../components/header"
import SideNav from "../components/sidenav"
import PageHeader from "../components/pageHeader";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { NavLink , useNavigate, useParams} from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';



const AddExhibitionArtwork = ()=>{

    let userInfo = JSON.parse(localStorage.getItem('admin-info'));
    const { id } = useParams();
    const navigate = useNavigate();
    const [artworkData, setArtworkData] = useState([]);
    const [artworkID, setArtworkID] = useState([]);
    const [artistID, setArtistID] = useState([]);
    const [statusID, setStatusID] = useState([]);
    const [filterChoiceID, setFilterChoiceID] = useState([]);

    const [exhibitionData, setExhibitionData] = useState({
        exhibitionTitle: '', exhibitionDate: '', description: ''
    });
    const [newdata, setNewdata] = useState({
        
        artworkID: 0, artistID: 0, statusID: 0
    });
    const fetchData = async (url, setData) => {
        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        fetchData(`https://igapi.heuristticminds.com/api/ExhibitionList/Get-GetExhibitionDetailsToEditByID?id=${id}`, (data) => {
            setExhibitionData(data);
            console.log("Exhibition Data:", data);
        });
    }, [id]);
    
    useEffect(() => {
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-ArtworkList', setArtworkID);
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindArtistList', setArtistID);
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-StatusList', setStatusID);
        
    }, []);

    const fetchDataFiltered = async () => {
        const { artworkID, artistID, statusID } = newdata;
        
        if (!artworkID && !artistID && !statusID) { // Only fetch data if filters are set
            setArtworkData([]); // Clear the table
            return;
        }

        const url = `https://igapi.heuristticminds.com/api/ExhibitionList/Get-GetArtworkListByExhibitionID?artworkID=${artworkID}&artistID=${artistID}&statusID=${statusID}&exhibitionID=${id}`;
        fetchData(url, setArtworkData);
    };

    useEffect(() => {
        fetchDataFiltered(); // Fetch filtered data when component mounts and when filter values change
    }, [newdata]);

    const onChangeHandle = (e) => {
        const { name, value } = e.target;
        setNewdata(prevState => ({
            ...prevState,
            [name]: parseInt(value, 10)
        }));
    };
    
     const columns = [
        {
            cell: (row) => {
                return (
                    <div className="pd_item" key={row.id}>
                        <div className="img_box">
                            <img src={`../../../images/products/thumbnail/${row.imageURL}`} className="pd_img" alt="" />                                                       
                        </div>
                        <div className="pd_content">
                            <span className="pd_brand">{row.productTitle}</span>
                            
                            <span className="pd_title">Art by:
                            <span className="btn_artist1">
                                    {row.artistName}
                                </span>
                            </span>
                            <span className="pd_title">Status : {row.statusName}</span>
                            {row.exhibitionID > 0 ? (
                                    <a className="btn3" onClick={() => handleAddToExhibition(row.exhibitionID, row.id)}>Remove from Exhibition</a>
                                    ) : (
                                    <a className="btn1" onClick={() => handleAddToExhibition(row.exhibitionID, row.id)}>Add to Exhibition</a>
                            )}
                        </div>
                    </div>
                );
            }
        },
    ]; 

    const paginationComponentOptions = {
        noRowsPerPage: true
    };

    const handleAddToExhibition =  async(exhibition_id, productId) => {
        let confirmed
        if(exhibition_id > 0){

            confirmed = window.confirm("Are you sure you want to Remove artwork from Exhibition ?");
        }
        else{

            confirmed = window.confirm("Are you sure you want to Add artwork to Exhibition ?");
        }
        
        if (!confirmed) {
            return; // If not confirmed, return early without deleting
        }
        const formData = {
            "exhibitionID":id,
            "productID": productId,
            "createdBy": userInfo.user_id
        };
        try {
            const response = await fetch(`https://igapi.heuristticminds.com/api/ExhibitionList/AddRemove-AddRemoveTDExhibitionArtwork`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData), // Replace with your data
            });
            if (response.ok) {
                
                if(exhibition_id > 0){

                    toast.info('Artwork Removed from Exhibition !');
                }
                else{
        
                    toast.success('Artwork Added to Exhibition !');
                }
                
                
            } else {
                // Server responded with an HTTP status code outside the range 200-299
                console.error('Failed to delete cart item. Status:', response.status);
            }
            fetchDataFiltered();
        }
        catch (error) {
            console.error('Error saving form data:', error);
        }
    };

    const handleDetails = (id) => {
       // navigate(`/artwork/${id}`);
    };

    const handleArtist = (artistId) => {
       // navigate(`/artist/${artistId}`);
    };

    return (

        <>
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">
                    <PageHeader name='Exhibition' icon='bi bi-activity' />
                    <div className="container-xl px-4">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <div className="card mb-4 vh-100">
                                    <div className="card-header">Exhibition Details</div>
                                    <div className="card-body">
                                    <NavLink className="btn btn-primary float-end" to={'/exhibition'} onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}><i className="bi bi-arrow-return-left"></i> Back</NavLink>
                                    <NavLink className="btn btn-primary float-end me-2" to={`/viewExhibition/${id}`} onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}><i className="bi bi-arrow-return-left"></i> View Exhibition</NavLink>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="col-sm-6 form-group mb-3">
                                                    <h5>
                                                        <label style={{ marginRight: '10px' }}>Exhibition Title : </label>
                                                        <label>{exhibitionData.exhibitionTitle}</label>  
                                                    </h5>
                                                </div>
                                                <div className="col-sm-6 form-group mb-3">
                                                    <h5>
                                                        <label style={{ marginRight: '10px' }}>Exhibition Date : </label>
                                                        <label> {exhibitionData.exhibitionDate}</label>  
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="col-sm-12 form-group mb-3">
                                                    <h5>
                                                        <label style={{ marginRight: '10px' }}>Exhibition Write-up : </label>
                                                        <span dangerouslySetInnerHTML={{ __html: exhibitionData.description }} />
                                                    </h5>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div className="row mb-4">
                                                <div className="col-sm-3">
                                                    <select value={newdata.artworkID} onChange={onChangeHandle} name="artworkID" className="form-control form-select">
                                                        <option value={0}>--Select Artwork--</option>
                                                        {artworkID.map(aType => (
                                                            <option key={aType.id} value={aType.id}>{aType.artwork}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="col-sm-3">
                                                    <select value={newdata.artistID} onChange={onChangeHandle} name="artistID" className="form-control form-select">
                                                        <option value={0}>--Select Artist--</option>
                                                        {artistID.map(aName => (
                                                            <option key={aName.id} value={aName.id}>{aName.artist}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="col-sm-3">
                                                    <select value={newdata.statusID} onChange={onChangeHandle} name="statusID" className="form-control form-select">
                                                        <option value={0}>--Select Status--</option>
                                                        {statusID.map(uStatus => (
                                                            <option key={uStatus.id} value={uStatus.id}>{uStatus.statusType}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                
                                            </div>
                                        <div className="col-md-12 pd-list">
                                            <DataTable
                                                columns={columns}
                                                data={artworkData}
                                                pagination
                                                noTableHead
                                                paginationComponentOptions={paginationComponentOptions}
                                                paginationPerPage={[20]}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>                    
                        </div>
                        <ToastContainer position="bottom-right" />
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    );

};
export default AddExhibitionArtwork;